import { useLanguage } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div data-testid="editorial-marquee" className="relative bg-slate-900 text-slate-100 py-4 overflow-hidden" dir="ltr">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center text-sm sm:text-base font-semibold tracking-wide whitespace-nowrap">
                <span className="px-6">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-lime-400 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
